// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bad84ab71f0986464e49ef1df6e0b607e0cf0779.chunk.bundle.js";
};